<template>
  <sfs-form-modal
    :id="modalId"
    title="Add a Recurring Payment Item"
    @on-hide="() => recurringPayment = null"
  >
    <b-form
      novalidate
      @submit.stop.prevent="handleSubmit"
    >
      <b-row>
        <b-col>
          <b-form-group
            label="Select a Recurring Payment"
            label-for="technician-payment-item-add-recurring-payment-recurring_payment_id"
          >
            <recurring-payments-select
              id="technician-payment-item-add-recurring-payment-recurring_payment_id"
              :user-id="user_id"
              :value="recurringPayment"
              :select-class="{ 'is-invalid': $v.form.recurring_payment_id.$dirty && $v.form.recurring_payment_id.$error }"
              @input="onRecurringPaymentChange"
            />
            <b-form-invalid-feedback
              v-if="$v.form.recurring_payment_id.$dirty"
              id="technician-payment-item-add-recurring-payment-recurring_payment_id-feedback"
            >
              <span v-if="!$v.form.recurring_payment_id.required">Please select a recurring payment.</span>
              <span v-if="!$v.form.recurring_payment_id.serverFailed">{{ serverErrors.reference_id }}</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <hr class="mt-4">

      <b-row>
        <b-col
          offset-lg="6"
          lg="3"
          order="2"
          order-lg="1"
        >
          <b-button
            variant="link-dark"
            block
            id="technician-payment-item-add-recurring-payment-close-button"
            @click="closeModal"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col
          lg="3"
          order="1"
          order-lg="2"
        >
          <b-button
            id="technician-payment-item-add-recurring-payment-submit-button"
            block
            type="submit"
            variant="primary"
            :disabled="processing"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </sfs-form-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import formMixin from '@/mixins/formMixin';
import formModalMixin from '@/mixins/formModalMixin';
import RecurringPaymentsSelect from '@/components/admin/recurringPayments/Select.vue';

export default {
  name: 'TechnicianPaymentsAddRecurringPaymentModal',
  mixins: [formMixin, formModalMixin],
  components: {
    RecurringPaymentsSelect,
  },
  props: {
    technician_payment_id: Number,
    user_id: Number,
    recurring_payment_id: Number,
  },
  data() {
    return {
      form: {
        recurring_payment_id: this.recurring_payment_id,
      },
      fieldLabels: {
        recurring_payment_id: 'Recurring Payment',
      },
      recurringPayment: null,
      modalId: 'technician-payment-item-add-recurring-payment-modal',
    };
  },
  validations: {
    form: {
      recurring_payment_id: {
        required,
        serverFailed() {
          return !this.hasServerErrors('reference_id');
        },
      },
    },
  },
  methods: {
    onRecurringPaymentChange(recurringPayment) {
      this.form.recurring_payment_id = recurringPayment ? recurringPayment.id : '';
      this.recurringPayment = recurringPayment;
    },
    handleSubmit() {
      if (this.hasFormErrors()) {
        return;
      }
      this.processing = true;
      this.$technicianPaymentsAPI
        .createRecurringPaymentItem(this.technician_payment_id, this.form)
        .then(() => {
          this.resetServerErrors();
          this.$v.$reset();
          this.$emit('on-save');
          this.closeModal();
          this.processing = false;
        })
        .catch((error) => {
          this.processServerErrors(error.response.data.errors);
          this.processing = false;
        });
    },
  },
};
</script>
